import { Flex, IconCertifiedSolid, View } from '@smarterservices/smarter-ui';
import React, { useEffect, useRef, useState } from 'react';
import './index.css';
import SinglePane from '../SinglePane';
import { config } from '../../config';
import Loader from '../Common/Loader';
import { usePaneViewer } from '../PaneViewer';

const Agreements = ({ setIsTaskComplete }) => {
  const agreementContainerRef = useRef(null);
  const [accepted, setAccepted] = useState(false);
  const [loading, setLoading] = useState(true);
  const { setShowNext, onNext } = usePaneViewer();

  //TODO [PR-2849]: Add better error handling on submit button, add more callbacks, bring agreemetns into SmarterUI.

  // Hide the Next button
  useEffect(() => {
    setShowNext(false);
    return () => setShowNext(true); // Clean up on unmount
  }, [setShowNext]);

  // Use MutationObserver to detect when content is added to the agreements container
  useEffect(() => {
    if (!agreementContainerRef.current) return;

    const observer = new MutationObserver((mutations, obs) => {
      if (agreementContainerRef.current?.children.length > 0) {
        setLoading(false);
        // Stop observing once we've detected content
        obs.disconnect();
      }
    });

    // Start observing the container
    observer.observe(agreementContainerRef.current, {
      childList: true,
      subtree: true
    });

    // Clean up the observer on unmount or if loading is set to false
    return () => observer.disconnect();
  }, [setLoading]);


  useEffect(() => {
    const agreementsComplete = () => {
      // Ensure the agreements have been injected into the page before removing the loader...
      if (agreementContainerRef.current && agreementContainerRef.current.children.length > 0) {
        //setLoading(false);
      }
      try {
        if (window.Agreements.agrFetched) {
          setAccepted(true);
          setIsTaskComplete(true);
          // now auto advance to next step since all agreements have been accepted...
          onNext();
        }
      } catch (error) {
        // No-op as the prop may be undefined
      }
    };

    agreementsComplete();

    document.addEventListener('agreementsComplete', () => agreementsComplete());

    const checkAgreements = () => {
      const params = JSON.parse(sessionStorage.getItem('spParams'));
      let agrOpts = {
        mode: 'inline',
        containerId: 'agreement-container',
        location: 'extension-recording-consent',
        target: Date.now(),
        account: params.installSid,
        application: config.session.agreementsApplicationSid,
      };
      window.Agreements.setup(agrOpts);
    };

    const renderAgreements = () => {
      const agrScript = document.querySelector('#agr-ui');
      if (!agrScript) {
        let agr = document.createElement('script');
        agr.id = 'agr-ui';
        agr.type = 'text/javascript';
        agr.async = true;
        agr.src =
          'https://s3.amazonaws.com/cdn.smarterservices.com/agreements/js/agreements.min.js';
        agr.onload = function () {
            checkAgreements();
        };

        document.body.appendChild(agr);
      }
      return null;
    };

    renderAgreements();
  }, []);

  return (
    <SinglePane>
      <Flex as="div"
        direction="column"
        height="100%"
        justifyContent="center"
        alignItems="center"
        padding="medium"
      >
        <Flex as="div" direction="column" alignItems="center" width="66%" height="100%">
          {!accepted ? (
            <View as="div" height="100%">
              <View id="agreement-container"
                elementRef={(el) => {
                  agreementContainerRef.current = el;
               }}></View>
              {loading && <Loader text='Loading agreements...' />}
            </View>
          ) : (
            <IconCertifiedSolid size="x-large" color="success" />
          )}
        </Flex>
      </Flex>
    </SinglePane>
  );
};

export default Agreements;
